/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetUserStatuses$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserStatusesRequest = createAction<PayloadData<void>>('GET_USER_STATUSES__GET_USER_STATUSES__REQUEST');
export const getUserStatusesSuccess = createAction<PayloadData<Array<DictionaryItem>>>('GET_USER_STATUSES__GET_USER_STATUSES__SUCCESS');
export const getUserStatusesFailure = createAction<PayloadData<Error, void, true>>('GET_USER_STATUSES__GET_USER_STATUSES__FAILURE');

export const getUserStatusesActions = [
    getUserStatusesRequest,
    getUserStatusesSuccess,
    getUserStatusesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserStatuses = (config?: GetUserStatuses$Config) => {
    return {
        CALL_API: {
            types: getUserStatusesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/user-status`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

